import React from 'react';
import { Navigate } from 'react-router-dom';

// Example of a simple function to check user role
const isAdmin = () => {

  const user = JSON.parse(localStorage.getItem('formData'));
  console.log(user);
  return user?.email === 'viddushiva@gmail.com';

};

const AdminRoute = ({ children }) => {
  return isAdmin() ? <>{children}</> : <Navigate to="/unauthorized" />;
};

export default AdminRoute;
